// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api-loreal-crm.h2h.tech',
  path: 'https://salonexpert.h2h.tech',
  googleApiKey: 'AIzaSyAsUiKPSixCbd9t5WJ8OhiSGw-5Ro_0R3c',
  ga: '', // Google Analitycs / GTM
  capchaKey: '6Lf7pasUAAAAALOfG_nbC_8Qz3NFjqLTyTOEU4Eg',
  projectName: 'salonexpert-test',
  development: false,
  login: '99999',
  password: 'Expert123!',
  webpush: {
    publicKey:
      'BG-0945gN9kttGQsoC7aoZSKaZakHAKLQVjCc7pnXL-CnZWQPGaT4cn0Jo8KxH1MHg-VOUnuqOhzmwXE1RkwUfM',
    privateKey: 'R924qwJA3rtN-eHW2Tl0dq14wOhq7-zT1q8iwpbB9l4',
  },
  lp_video: {
    hairdressing_for_the_future: '2022/04/01 21:30:00',
    hairdressing_for_the_future_press: '2022/04/02 21:00:00',
    live_new_curl_expression: '2022/04/19 13:30:00',
  },
  oneScriptDataDomainKey: null,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
